<template>
    <Switch
        :id="id"
        :class="[{ onboarded: disabled }]"
        :disabled="disabled"
        :model-value="modelValue"
        class="operability-switch"
        @update:model-value="onChange"
    />
</template>
<script setup>
import Switch from '@/Components/Switch.vue';

defineProps({
    modelValue: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    id: String,
});

const emit = defineEmits(['changed', 'update:modelValue']);
const onChange = (value) => {
    emit('update:modelValue', value);
    emit('changed', value);
};
</script>
